var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NgZone, AfterViewInit, OnDestroy } from '@angular/core';
import { Project } from '../../../models/index';
import { MapPlanBase } from './map-plan-base.model';
import { ListTrackingService } from './../../../utils/list-tracking.service';
var MapPlanBuildingBaseComponent = /** @class */ (function (_super) {
    __extends(MapPlanBuildingBaseComponent, _super);
    function MapPlanBuildingBaseComponent(zone, window, listTrackingService) {
        var _this = _super.call(this, zone, window) || this;
        _this.zone = zone;
        _this.window = window;
        _this.listTrackingService = listTrackingService;
        _this.buildingFloors = [];
        return _this;
    }
    MapPlanBuildingBaseComponent.prototype.ngAfterViewInit = function () {
        this.runImgMappingScript();
    };
    MapPlanBuildingBaseComponent.prototype.ngOnDestroy = function () {
        this.removeImgMappingScript();
    };
    return MapPlanBuildingBaseComponent;
}(MapPlanBase));
export { MapPlanBuildingBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/map-plan-building-base.component.ts.pre-build-optimizer.js